export * from './progress-bar';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@angular/material/progress-bar/index.js
// module id = 452
// module chunks = 8